import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/noone/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"
import AssessmentPage from "../../components/noone/AssessmentPage"

const assessment = () => (
  <Layout>
    <SEO title={PAGE.title.assessment} siteTitle="noone" />
    <HeadingL title={PAGE.title.assessment} target="noone" />
    <AssessmentPage />
  </Layout>
)

export default assessment
